import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import StarterChart from "../Charts/StarterChart";
const Starter = require("../../Assets/Images/Starter.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    fontFamily: "Lato",
  },
  coverTitle: {
    marginBottom: "5px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426b88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  secondsection: {
    marginTop: "5px",
    width: "100%",
    paddingRight: "20px",
    flexDirection: "column",
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "flex-start",
    fontFamily: "Lato",
  },
  subtitle: {
    fontSize: "18px",
    lineHeight: "35px",
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    justifyContent: "flex-start",
    display: "flex",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "20px",
  },
  coverImage: {
    width: "240px",
    height: "160px",
    marginHorizontal: 10,
  },
  section: {
    textAlign: "left",
    maxWidth: "800px",
    padding: 16,
  },
  paragraph: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#00577D",
    lineHeight: "18px",
    textAlign: "left",
    // marginTop: "20px",
    fontFamily: "Lato",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#245775",
    textAlign: "left",
    marginTop: "20px",
    fontFamily: "Lato",
  },
  covertitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#00577D",
    textAlign: "left",
    lineHeight: "35px",
    fontFamily: "Lato",
  },
  chartcontainer: {
    padding: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    width: "100%",
  },
  title: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    marginHorizontal: 120,
  },
  imageContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    width: "100%",
  },
  image: {
    width: "100%",
    maxWidth: "400px",
    marginTop: "20px",
    alignSelf: "center",
  },
  separator: {
    border: "1px solid #000000",
    backgroundColor: "#000000",
  },
  item: {
    marginBottom: 5,
    color: "#00577D",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "left",
    lineHeight: "18px",
  },
});
const StarterQuadrantChart360 = ({apiData}) => {

  const [highestStarter, setHighestStarter] = useState('')
    const [snapshotResult, setSnapshotResults] = useState([])
    const [variablsMapArray, setVariableMapArray] = useState()
    const [starterLabel, setStarterLabel] = useState([])
    const [highestScoredVariable, setHighestScoredVariable] = useState('')
  
    const variableMap = apiData?.variables?.reduce((acc, el) => {
      acc[el.variable] = el.score;
        return acc;
    }, {});
    useEffect(() => {
      if (apiData?.variables) {
        const nextMap = apiData.variables.reduce((acc, el) => {
          acc[el.variable] = el.score;
          return acc;
        }, {});
        setVariableMapArray(nextMap);
      }
        console.log("apiData", apiData)
    }, [apiData?.variables]);

     useEffect(() => {
        let highestScore = -Infinity;
        let highestVariable = "";
        let results = [];
        let labelsArray = [];
        
        if (variablsMapArray) {
          console.log(variablsMapArray);
          const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
          const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
          const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
          const strength_r1_m = variablsMapArray["str_round1_m"] || 0;
        
          const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
          const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
          const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
          const strength_r2_m = variablsMapArray["str_round2_m"] || 0;
        
          const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
          const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
          const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
          const strength_r1_l = variablsMapArray["str_round1_l"] || 0;
        
          const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
          const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
          const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
          const strength_r2_l = variablsMapArray["str_round2_l"] || 0;
        
          const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
          const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
          const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
          const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);
              
        
          console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
          // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
          let testingVarsM2Pair = [{"name": "heart", "score": heart_highest},{"name": "soul", "score": soul_highest},{"name": "mind", "score": mind_highest}, {"name": "strength", "score": strength_highest}];
          console.log("testingVarsM2Pair",testingVarsM2Pair);
        
          highestVariable = testingVarsM2Pair.reduce((max, current) => 
            current.score > max.score ? current : max, { name: "", score: -Infinity }
          );
        
        
          let most_score = Math.max(heart_r1_m,soul_r1_m,mind_r1_m,strength_r1_m)
          let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
          let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
          let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2
        
          console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
          if ( least_score >= second_least_score ) {
            least_score = ( second_least_score - 1 )
          }
        
          const total = most_score + second_most_score + least_score + second_least_score;
        
          const most_per = (most_score / total) * 100;
          const second_most_per = (second_most_score / total) * 100;
          const least_per = (least_score / total) * 100;
          const second_least_per = (second_least_score/ total) * 100 
        
          console.log("scores-",most_score,second_most_score,least_score,second_least_score)
          console.log("scores-per",most_per,second_most_per,least_score,second_least_per)
        
          
          let labels = testingVarsM2Pair.map(item => item.name);
        
          const labels_arr = ["heart", "soul", "mind", "strength"];
        
          const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
          const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
          const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
          const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
        
          const most_score_label = Math.max(...mostValues);
          const second_most_score_label = Math.max(...secondMostValues);
          const least_score_label = Math.max(...leastValues);
          const second_least_score_label = Math.max(...secondLeastValues);
        
          const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
        
          const most_label = getLabel(mostValues, most_score_label);
          const second_most_label = getLabel(secondMostValues, second_most_score_label);
          const least_label = getLabel(leastValues, least_score_label);
          const second_least_label = getLabel(secondLeastValues, second_least_score_label);
        
          console.log(most_label , 'most_label')
          const getPercentageOrder = ( label ) => {
            if ( label === most_label?.toLowerCase() ) {
              return most_per;
            }
            if ( label === second_most_label?.toLowerCase() ) {
              return second_most_per;
            }
            if ( label === least_label?.toLowerCase() ) {
              return least_per;
            }
            if ( label === second_least_label?.toLowerCase() ) {
              return second_least_per;
            }
        
            return 0
          }
        
          console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
          console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)
        
          // order should be most > second most > least > second least
          // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
          results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'
             
          // labelsArray = [...labelsArray, ...labels];
          // labelsArray = [least_label, second_least_label, second_most_label, most_label];
          labelsArray = ['mind', 'soul', 'strength', 'heart'];
        
          console.log('highestVariable', highestVariable)
          console.log("pie chart results", results);
          console.log("pie chart labelsArray", labelsArray);
        
          setHighestStarter(most_label);
          // setStarterScore(most_per);
          setSnapshotResults(results);
          setStarterLabel(labelsArray);
          setHighestScoredVariable(highestVariable?.name)
          // getMostAndSecondMostVaribale(apiData)
        
        }
        
      }, [variablsMapArray]);
      
      const getMostScoredLabel = () => {
        if (highestScoredVariable === 'heart') return "HEART"
        if (highestScoredVariable === 'soul') return "SOUL"
        if (highestScoredVariable === 'mind') return "MIND"
        if (highestScoredVariable === 'strength') return "STRENGTH"
        else return ""
      }


      console.log("snapshotResult", snapshotResult)
      console.log("starterLabel", starterLabel)

  return (
    <View style={styles.coverSection}>
      <View>
        <Text style={styles.coverTitle}>STARTER QUADRANT 360</Text>
        <Text style={styles.paragraph}>
          Each of us has a quadrant of origin: a "home base" that—through a
          combination of nature and nurture—feels most natural, comfortable, and
          intuitive for each of us. Unlike the many personality systems in use
          today, these four quadrants offer a fresh way of understanding how you
          show up in the world. These integrative parts of who we are offer
          individuals and teams incredible perspectives toward understanding how
          we love, live, work, contribute, and lead personally and
          professionally.
        </Text>
        <Text style={styles.paragraph}>
          Your starting quadrant highlights the characteristics that feel most
          authentic to your natural, primary, or dominant way of being—the
          stance or approach that most reflect your instinctive way of relating
          to yourself and others. Think about how others have described you, and
          try to separate the person you think you should be from the person you
          already are. Rest assured, none of the four is superior or inferior.
          Having all four quadrants in each of us is integral for wholeness and
          health, but one quadrant is often a more dominating starting block.
        </Text>
      </View>
      <View style={styles.secondsection}>
        <Text style={styles.subtitle}>STARTER QUADRANT OVERVIEW CHART </Text>
        <View style={styles.chartcontainer}>
          <View style={styles.header}>
            <Text style={styles.title}>SELF</Text>
            <Text style={styles.title}>360</Text>
          </View>
          <View style={styles.imageContainer}>
            <StarterChart originalData={snapshotResult.map(value => Math.round(value))}/>
            <View style={styles.separator} />
            <StarterChart originalData={snapshotResult.map(value => Math.round(value))}/>
          </View>
        </View>
      </View>
      <View style={styles.section}>
        <Text style={styles.paragraph}>
          These charts reflect both your own results and the combined results
          calculated with all the observer scores (excluding yours). The
          highest result is your starter quadrant. We will reflect more on your
          flow into the other quadrants in the upcoming section.
        </Text>
      </View>
    </View>
  );
};

export default StarterQuadrantChart360;
